import { useGetCheckApprovedByCategoryQuery } from '@/hooks/qna/qna.gql.impl';
import { AgreementCategory } from '@/types/bff/gql-schema';

interface Props {
  category: AgreementCategory;
}

const useGetCheckApprovedByCategory = ({ category }: Props) => {
  const { data } = useGetCheckApprovedByCategoryQuery(
    {
      category: category,
    },
    { select: (response) => response.checkApproved },
  );

  return { data };
};
export default useGetCheckApprovedByCategory;
